import type { AttachmentInput, ShareBatch } from 'generated/gql';
import { AttachmentType } from 'generated/gql';
import { t } from '@lingui/macro';
import { mapShareSeriesToShareSeriesInput } from 'graphql/input-mappers/ShareSeries';

export const attachmentInputsForShareBatches = (shareBatches: ShareBatch[]): AttachmentInput[] =>
  shareBatches.map((shareBatch) => ({
    details: null,
    shareSeries: mapShareSeriesToShareSeriesInput(shareBatch.shareSeries),
    ownerPartyId: shareBatch.shareholder.id,
    type: AttachmentType.Prejudgement,
  }));

export const attachmentOptions = () => [
  {
    value: AttachmentType.Prejudgement,
    label: t`Conservatoir`,
  },
  {
    value: AttachmentType.Enforceable,
    label: t`Executoriaal`,
  },
];
